export default "__VITE_ASSET__CNl_c1sl__"